<template>
	<div class="m-popup-bottom-list" v-if="vanpopup">
		<van-popup
			v-model="vanpopup"
			position="bottom"
			round
			:safe-area-inset-bottom="true"
			closeable
			:get-container="getContainer"
			class="m-popup-bottom-list-popup"
			:class="wrapClassName"
			@click-close-icon="handleClose"
		>
			<div class="list-content">
				<div class="list-content-title">
					{{ title }}
				</div>
				<div class="check-wrap">
					<!-- 多选 -->
					<van-checkbox-group v-model="result" v-if="mutliMode">
						<ul class="list-unstyle">
							<li
								class="item flex-row-main-space-between"
								v-for="(item, index) in list"
								clickable
								:key="item.id"
								@click="toggleCheck(index)"
							>
								<span>{{ item.label }}</span>
								<van-checkbox :name="item.id" ref="checkboxes">
									<template #icon="props">
										<i class="iconfont" :class="props.checked ? 'iconyiguanzhu1' : ''"></i>
									</template>
								</van-checkbox>
							</li>
						</ul>
					</van-checkbox-group>
					<!-- 单选 -->
					<van-radio-group v-model="result" v-else>
						<ul class="list-unstyle">
							<li
								class="item flex-row-main-space-between"
								v-for="(item, index) in list"
								clickable
								:key="item.id"
								@click="toggleRadio(index)"
							>
								<span>{{ item.label }}</span>
								<van-radio :name="item.id" ref="radioboxes">
									<template #icon="props">
										<i class="iconfont" :class="props.checked ? 'iconyiguanzhu1' : ''"></i>
									</template>
								</van-radio>
							</li>
						</ul>
					</van-radio-group>
				</div>
				<button type="primary" class="btn btn-login btn-gradient" @click="handleOk">{{ $t('确 定') }}</button>
			</div>
		</van-popup>
	</div>
</template>

<script>
import { Popup, Checkbox, CheckboxGroup, RadioGroup, Radio } from 'vant';
export default {
	props: {
		// 控制弹出框显示
		visible: {
			default: false,
			type: Boolean
		},
		// 是否多选
		mutliMode: {
			type: Boolean,
			default: true
		},
		list: {
			type: Array,
			default: () => []
		},
		title: {
			type: String,
			default: ''
		},
		defaultValue: {
			type: [Array, String, Number],
			default: ''
		},
		getContainer: {
			type: String,
			default: null
		},
		wrapClassName: {
			type: String,
			default: ''
		}
	},
	components: {
		'van-popup': Popup,
		'van-checkbox-group': CheckboxGroup,
		'van-checkbox': Checkbox,
		'van-radio-group': RadioGroup,
		'van-radio': Radio
	},
	computed: {
		vanpopup: {
			get() {
				console.log(this.list);
				return this.visible;
			},
			set(value) {
				this.$emit('update:visible', value);
			}
		}
	},
	mounted() {
		if (
			(this.mutliMode && this.defaultValue && this.defaultValue.length) ||
			(!this.mutliMode && this.defaultValue !== '')
		) {
			this.result = this.defaultValue;
		} else {
			this.result = this.mutliMode ? [] : '';
		}
	},
	data() {
		return {
			// list: ['a', 'b', 'c', 'd', 'e'],
			result: []
		};
	},
	methods: {
		toggleCheck(index) {
			this.$refs.checkboxes[index].toggle();
		},

		toggleRadio(index) {
			this.$refs.radioboxes[index].toggle();
		},

		handleClose() {
			this.$emit('update:visible', false);
		},

		handleOk() {
			this.$emit('handleOk', this.result, this.list);
			this.handleClose();
		}
	}
};
</script>
